import { ArchiveMutation } from "../../hooks/useArchiveState";
import { PatientAllergyControllerApi } from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

/**
 *
 * @author Rajkumar Rathod
 */
export const useArchiveAllergy = () =>
  useMutationWithLoading(
    async (param: {
      patientAllergyId: string;
      status: boolean;
      xTENANTID?: string;
    }) =>
      new PatientAllergyControllerApi(
        getConfigObject()
      ).updatePatientAllergyArchiveStatus(
        param.patientAllergyId,
        param.status,
        param.xTENANTID //xTENANTID
      )
  );

  export const useArchiveAllergyMutation = () =>
    useMutationWithLoading(
      async (param: ArchiveMutation) =>
        new PatientAllergyControllerApi(
          getConfigObject()
        ).updatePatientAllergyArchiveStatus(
          param.id,
          param.status,
          param.xTENANTID //xTENANTID
        )
    );
  